import { useMemo, useState } from 'react'
import * as BalancaHttp from '../../../../../services/api/https/patio/balanca.http'
import { errorHandler } from '../../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  SAVE: 'Salvando informações da balança',
  SUCCESS: 'Salvo com sucesso',
}

const MANDATORY_FIELDS = {
  NAME: 'O nome da balança deve ser preenchido',
}

const INITIAL = {
  id: undefined,
  name: '',
  tp_id: 0,
  actived: true,
}

export default function useBalancaModal() {
  const [state, setState] = useState({
    balanca: { ...INITIAL },
    loadingMessage: LOAD_MESSAGE.NONE,
    errorMessage: null,
  })

  const localDispatch = useMemo(() => {
    return {
      start(balanca) {
        setState(prev => ({ ...prev, balanca: balanca ? { ...balanca } : { ...INITIAL } }))
      },
      onChange(field, value) {
        setState(prev => ({ ...prev, balanca: { ...prev.balanca, [field]: value } }))
      },
      onBtnSalvarClicked(selectedTp) {
        if (!state.balanca.name || state.balanca.name.trim() === '')
          setState(prev => ({ ...prev, errorMessage: MANDATORY_FIELDS.NAME }))
        else if (!selectedTp || selectedTp === 0)
          setState(prev => ({ ...prev, errorMessage: 'Selecione o Operador Logístico' }))
        else setState(prev => ({ ...prev, loadingMessage: LOAD_MESSAGE.SAVE }))
      },
      async save(selectedTp) {
        try {
          const payload = {
            ...state.balanca,
            name: (state.balanca.name || '').trim(),
            tp_id: selectedTp,
          }
          const saved = await BalancaHttp.saveBalanca(payload)
          setState(prev => ({ ...prev, loadingMessage: LOAD_MESSAGE.SUCCESS }))
          return saved
        } catch (err) {
          setState(prev => ({
            ...prev,
            loadingMessage: LOAD_MESSAGE.NONE,
            errorMessage: errorHandler(err),
          }))
          throw err
        }
      },
      reset() {
        setState({ balanca: { ...INITIAL }, loadingMessage: LOAD_MESSAGE.NONE, errorMessage: null })
      },
    }
  }, [state.balanca])

  return { state, localDispatch }
}
